export function UserBannerCarousel({ dynamicBanners, bannerIndex, setBannerIndex }) {
  if (dynamicBanners.length === 0) return null;

  const current = dynamicBanners[bannerIndex % dynamicBanners.length];

  return (
    <div className="mb-4 sm:mb-8">
      <p className="text-[10px] sm:text-xs text-slate-500 uppercase tracking-wider mb-1 sm:mb-1.5 font-semibold">Patrocinador</p>
      <a href={current.url} target="_blank" rel="noopener noreferrer" className="block" data-testid="rotating-banner">
        <div className="relative w-full h-28 sm:h-40 md:h-52 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer">
          <img src={current.image_url} alt={current.title} className="w-full h-full object-cover" />
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent pt-8 pb-2 px-3 sm:pb-3 sm:px-5">
            <h3 className="text-sm sm:text-xl md:text-2xl font-black text-white drop-shadow-lg uppercase">{current.title}</h3>
          </div>
          <div className="absolute bottom-2 sm:bottom-3 right-0 left-0 flex justify-center gap-1.5 sm:gap-2">
            {dynamicBanners.map((_, i) => (
              <button key={`dot-${i}`} onClick={(e) => { e.preventDefault(); setBannerIndex(i); }}
                className={`w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full transition-all ${i === bannerIndex % dynamicBanners.length ? 'bg-white w-4 sm:w-6' : 'bg-white/40'}`} />
            ))}
          </div>
        </div>
      </a>
      {current.description && (
        <p className="text-[10px] sm:text-sm text-slate-500 mt-1">{current.description}</p>
      )}
    </div>
  );
}
